import { Pipe, PipeTransform } from '@angular/core';
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { actionTypeOptions } from "libraries/interfaces/action-type-options";

@Pipe({
    name: 'transcodeActionType'
})

export class TranscodeActionTypePipe implements PipeTransform {
    public transform(typeCode: string): string {
        if(!typeCode){
            return null;
        }
        const relatedOption: IMultiselectOptions = actionTypeOptions
            .find((option: IMultiselectOptions): boolean => (option.value as string).toLowerCase() === typeCode.toLowerCase());

        return relatedOption?.label ? relatedOption.label : typeCode;
    }
}
